import React, { useState, useEffect } from "react";
import { setTitle } from "../../helpers/MetaTag";
import Button from "../../components/form/Button";
import Input from "../../components/form/Input";
import Image from "../../components/elements/Image";
import ButtonFile from "../../components/form/ButtonFile";
import Textarea from "../../components/form/Textarea";
import toastr from "toastr";
import { useNavigate } from "react-router";
import { useParams } from "react-router";

import { allowedImageExtensions } from "../../helpers";
import { postData } from "../../services/api";

import { useTranslation } from "react-i18next";

const ManageBanner = () => {
  const { id } = useParams();
  if (id) {
    setTitle("Succession Planning Software for your Business with Succession Now | Edit Banner");
  } else {
    setTitle("Succession Planning Software for your Business with Succession Now | Add Banner");
  }
  const { t } = useTranslation();

  const navigate = useNavigate();
  const [details, setDetails] = useState({});
  const [name, setName] = useState("");
  const [image, setImage] = useState("");
  const [showLogo, setShowLogo] = useState("");
  const [description, setDescription] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [isManage, setIsManage] = useState(false);
  const [isCancel, setIsCancel] = useState(false);
  // const [buttonDisabled,setButtonDisabled]=useState(false)

  useEffect(() => {
    // Banner details
    const loadDetails = async () => {
      try {
        const result = await postData("banner/details", {
          id: id,
        });
        if (result.data) {
          setDetails(result.data);
        }
      } catch (err) {
        console.log(err.message);
      }
    };
    if (id) {
      loadDetails();
    } else {
      setDetails(null);
    }
  }, [id]);

  useEffect(() => {
    setName(details?.name);
    setSubTitle(details?.sub_title);
    setDescription(details?.description);
    setShowLogo(details?.image);
    // setShowLogo(file?.path)
  }, [details]);

  // On cancel.........................................

  const onCancel = async (e) => {
    setIsCancel(true);
    if (id) {
      setName(details?.name);
      setSubTitle(details?.sub_title);
      setDescription(details?.description);
      // setShowLogo(updatedImage.path)
      setShowLogo(details?.image);
    } else {
      setName("");
      setDescription("");
      setSubTitle("");
      setImage("");
      setShowLogo("/male-placeholder-image.jpeg");
    }
    setIsCancel(false);
  };

  const onSubmit = async (e) => {
    //if (isManage)
    //  return
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", name);
    formData.append("sub_title", subTitle);
    formData.append("description", description);
    formData.append("image", image);
    setIsManage(true);
    try {
      let path = "";
      let payload = "";
      if (id) {
        path = "banner/update";
        formData.append("id", id);
        payload = formData;
      } else {
        path = "banner/create";
        payload = formData;
      }
      const result = await postData(path, payload);
      if (result.status && result.status === 200) {
        toastr.success(result.message);
        setIsManage(false);

        return navigate("/banners");
      } else {
        toastr.error(result.message);
        setIsManage(false);
      }
    } catch (error) {
      toastr.error(error.message);
      setIsManage(false);
    }
  };

  const onImgChange = (e) => {
    if (e.target.files[0]) {
      const ext = e.target.files[0].type.split("/")[1];
      if (![...allowedImageExtensions()].includes(ext)) {
        toastr.error("Please upload a valid image");
      } else {
        var output = document.getElementById("image1");
        output.src = URL.createObjectURL(e.target.files[0]);
        output.onload = function () {
          URL.revokeObjectURL(output.src); // free memory
        };
        setImage(e.target.files[0]);
      }
    }
  };

  return (
    <div className="border bg-white border-gray-200 p-4 shadow-md rounded-xl">
      <div className="relative flex justify-between items-center mb-3 flex-wrap sm:flex-nowrap gap-y-4">
        <div className="text-2xl font-bold">{id ? t("edit_banner") : t("add_banner")}</div>
      </div>
      <div className="grid grid-cols-12 gap-4">
          <div className="col-span-12 lg:col-span-3 border-r border-slate-200">
            <div className="p-2 2xl:p-4">
                <div className="py-6 px-6 flex flex-col space-y-2 relative">
                    <div className="relative group w-full aspect-1 border-2  mx-auto overflow-hidden rounded-full border-dark-teal-500">
                      <Image src={showLogo} alt={"Admin"} width={"100%"} height={"100%"} effect={"blur"} classes={"object-contain"} id={"image1"} />
                    </div>
                  </div>
                  <div className="divide-x divide-slate-200 flex items-center justify-center rounded-b border-t border-slate-200 pt-5">
                    <ButtonFile buttonType={"button"} buttonIcon={"fa-light fa-image"} buttonIconPosition={"left"} buttonLabel={t("upload_image")}  functions={onImgChange} accepts={"image/*"} />
                  </div>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-9 flex flex-col">
            <div className="space-y-4 ">
              <div className="grid grid-cols-1 sm:grid-cols-12 gap-4">
                    <div className="relative col-span-12 sm:col-span-6">
                      <Input label={t("title")} labelClasses={"!text-xs"} inputType={"text"} inputPlaceholder={t("enter_title")} inputValue={name} setInput={setName} />
                    </div>
                    <div className="relative col-span-12 sm:col-span-6">
                      <Input label={t("sub_title")} labelClasses={"!text-xs"} inputType={"text"} inputPlaceholder={t("enter_sub_title")} inputValue={subTitle} setInput={setSubTitle} />
                    </div>
                    <div className="relative col-span-12">
                      <Textarea label={t("description")} labelClasses={"!text-xs"} inputValue={description} inputPlaceholder={t("enter_description")} setTextarea={setDescription} />
                    </div>
              </div>

              <div className="flex justify-end gap-4 mt-5">
                  <Button buttonLabelClasses="" buttonType={"button"} buttonIcon={isCancel ? "fa-light fa-spinner fa-spin" : "fa-light fa-times"} buttonIconPosition={"left"} buttonLabel={t("cancel")} buttonClasses={"!bg-slate-200 !text-slate-600 border border-slate-300"} functions={onCancel} buttonHasLink={false} buttonDisabled={isCancel} />
                  <Button buttonClasses="" buttonLabelClasses="" buttonType={"button"} buttonIcon={isManage ? "fa-light fa-spinner fa-spin" : "fa-light fa-floppy-disk"} buttonIconPosition={"left"} buttonLabel={t("save")} functions={onSubmit} buttonHasLink={false} buttonDisabled={isManage} />
                </div>
            </div>
          </div>
      </div>
    </div>
  );
};

export default ManageBanner;
